<template>
  <div v-if="images.length" class="alt-img" :for="`image-radio-${index}`">
    <div v-if="data.video" class="video">
      <div class="layer"></div>
      <div class="product-video-wrapper">
        <span class="video-control-play-dark-medium"></span>
      </div>
      <PictureView :image-url="images[0].path" :alt="seoAlt" :image-sizes-by-breakpoints="imageSizesByBreakpoints" lazy-load />
    </div>
    <div v-else-if="data.imageIndicatorEnabled" class="ar-indicator">
      <div class="layer"></div>
      <div class="product-ar-wrapper">
        <div class="indicator">
          <div class="camera-dark-small"></div>
          <div class="try-it-on-label show-for-mlarge">{{ imageLabel }}</div>
        </div>
      </div>
      <PictureView :image-url="images[0].path" :alt="seoAlt" :image-sizes-by-breakpoints="imageSizesByBreakpoints" lazy-load />
    </div>
    <template v-else>
      <PictureView :image-url="data.path" :alt="seoAlt" :image-sizes-by-breakpoints="imageSizesByBreakpoints" lazy-load />
    </template>
    <div class="border" :class="{ invisible: currentPage - 1 !== index }"></div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import PictureView from '~/components/common/Media/PictureView';

const imageSizesByBreakpoints = {
  small: 44,
  medium: 60,
  large: 44,
  mlarge: 82,
  xlarge: 82,
};

const props = defineProps({
  data: {
    /** @type import('vue').PropType<Image> */
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    default: 0,
  },
  images: {
    /** @type import('vue').PropType<Array<Image>> */
    type: Array,
    default: () => [],
  },
  videoId: {
    type: String,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
  seoAlt: {
    type: String,
    default: '',
  },
});

const imageLabel = computed(() => (props.data.imageIndicatorEnabled && props.data.vtoEligibleExperiment ? 'TRY IT ON' : 'VIEW IN ROOM'));
</script>

<style lang="scss" scoped>
@import '~@csgIcons/new/video-control-play-dark-medium';
@import '~@csgIcons/new/camera-dark-small';

.alt-img {
  display: block;
  width: rem-calc(82);
  height: rem-calc(102);
  max-height: rem-calc(102);
  position: relative;
  cursor: pointer;
  @include breakpoint(medium only) {
    min-width: 100%;
    width: 100%;
    height: rem-calc(75);
  }
  @include breakpoint(large down) {
    width: rem-calc(44);
    height: rem-calc(55);
    max-height: rem-calc(55);
  }
  .video,
  .ar-indicator {
    width: 100%;
    height: 100%;
    .layer {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 9;
      background-color: rgba(255, 255, 255, 0.4);
    }
    .product-video-wrapper {
      width: rem-calc(24);
      height: rem-calc(24);
      border-radius: 50%;
      position: absolute;
      z-index: 10;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
      justify-content: center;
      .play-control {
        width: rem-calc(24);
        height: rem-calc(24);
        background-size: rem-calc(24) rem-calc(24);
      }
    }
  }

  .border {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border: 2px solid $black;
    top: 0;
    left: 0;
    z-index: 10;
  }
}
</style>

<style lang="scss" brand="mcom" scoped>
@import '~settingSCSS';

.ar-indicator {
  position: relative;

  .product-ar-wrapper {
    width: 80%;
    position: absolute;
    z-index: 10;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .camera-dark-small {
      width: rem-calc(16);
      height: rem-calc(16);
      background-size: rem-calc(16) rem-calc(16);
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .indicator {
    width: 100%;
    text-align: center;
  }
}

.try-it-on-label {
  @include body('heavy-sm');

  text-align: center;
}
</style>
